(function () {
  function attachToForms() {
    document.querySelectorAll('form').forEach(function (form) {
      form.addEventListener('submit', function () {
        var T = window.LUMINA_TRACKING;
        if (!T) return;
        var F = T.first;
        var L = T.latest;

        // Session duration in minutes
        var startTime = parseInt(sessionStorage.getItem('lumina_session_start') || Date.now());
        var durationSec = Math.floor((Date.now() - startTime) / 1000);
        var durationMin = Math.floor(durationSec / 60);
        var durationStr = durationMin + ' min ' + (durationSec % 60) + ' sec';

        function fill(id, val) {
          var el = document.getElementById(id);
          if (el) el.value = val || '(not set)';
        }

        // ── Existing fields ──
        fill('utm_source',       L.utm_source);
        fill('utm_medium',       L.utm_medium);
        fill('utm_campaign',     L.utm_campaign);
        fill('utm_term',         L.utm_term);
        fill('utm_content',      L.utm_content);
        fill('referrer',         L.referrer);
        fill('first_page',       F.landing_page);
        fill('pages_viewed',     T.total_pages);
        fill('session_duration', durationStr);
        fill('submission_time',  T.submission_time);

        // ── New fields ──
        fill('lumina_device',           T.device);
        fill('lumina_screen',           T.screen);
        fill('lumina_total_sessions',   T.total_sessions);

        fill('lumina_first_source',     F.utm_source);
        fill('lumina_first_medium',     F.utm_medium);
        fill('lumina_first_medium_cls', F.medium_classified);
        fill('lumina_first_campaign',   F.utm_campaign);
        fill('lumina_first_term',       F.utm_term);
        fill('lumina_first_referrer',   F.referrer);
        fill('lumina_first_landing',    F.landing_page);
        fill('lumina_first_ai',         F.ai_source);
        fill('lumina_first_social',     F.social_source);
        fill('lumina_first_time',       F.timestamp_beirut);

        fill('lumina_conv_session_num', L.session_number);
        fill('lumina_conv_source',      L.utm_source);
        fill('lumina_conv_medium',      L.utm_medium);
        fill('lumina_conv_medium_cls',  L.medium_classified);
        fill('lumina_conv_campaign',    L.utm_campaign);
        fill('lumina_conv_term',        L.utm_term);
        fill('lumina_conv_referrer',    L.referrer);
        fill('lumina_conv_landing',     L.landing_page);
        fill('lumina_conv_ai',          L.ai_source);
        fill('lumina_conv_social',      L.social_source);
        fill('lumina_conv_time',        L.timestamp_beirut);
        fill('lumina_country', T.country);
        fill('lumina_city',    T.city);

      });
    });
  }

  // ── OpenAI Ads: Form Submission conversion ──
  // Fires only after a successful Shopify contact form submit (page reloads with ?contact_posted=true).
  // Waits up to 5s for the oaiq base pixel, and fires once per URL per session (no double count on refresh).
  function fireOaiFormConversion() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('contact_posted') !== 'true') return;

    var key = 'lumina_oai_fs_' + window.location.pathname + window.location.search;
    try { if (sessionStorage.getItem(key)) return; } catch (e) {}

    var tries = 0;
    (function attempt() {
      if (typeof window.oaiq === 'function') {
        window.oaiq(
          'measure',
          'registration_completed',
          { type: 'customer_action' }
        );
        try { sessionStorage.setItem(key, '1'); } catch (e) {}
        return;
      }
      if (++tries < 20) setTimeout(attempt, 250);
    })();
  }

  function init() {
    attachToForms();
    fireOaiFormConversion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
